// extracted by mini-css-extract-plugin
export default {"Link":"bAMyvHHL3Qy7mU7wvKed","Danger":"uCQiIpfE5XDQftxKlSty","Disabled":"YzfNwIpVbchrk32_XGqX"};